var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('div',{staticClass:"pb-16"},[_c('v-card',{staticClass:"shadow-off",attrs:{"loader-height":"2","loading":_vm.loading,"disabled":_vm.loading}},[_c('v-card-text',{},[_c('div',[_c('ApprovalsList',{attrs:{"display":"edit","filterData":_vm.filterOptionsData},on:{"loading":_vm.setLoading}})],1)])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }